import React, { } from 'react';

import commonComponents from '../../components/common';

const Splash = () => {
  const { BusyOverlay } = commonComponents;

  return (
    <div className="auth-page flex items-center">
      <BusyOverlay />
    </div>
  );
}

export default Splash;
